import { type OrganizationDto as NewOrganizationDto } from '../queries/organization.ts';
import { type Organization } from '@funnellab/shared/src/types/directus.ts';
import { type OrganizationDto } from '@src/api/api.types.ts';
import { directusClient } from '@src/api/DirectusClient.ts';
import { mapCountryDTOtoCountry } from './CountryService.ts';
import { getApiClientByBodyType } from '../ApiClients/getApiClientByBodyType.ts';

const DTOtoWizard = (data: OrganizationDto): NewOrganizationDto => ({
  ...data,
  billingEmail: data.billingEmail ?? null,
  city: data.city ?? null,
  street: data.street ?? null,
  zip: data.zip ?? null,
  vatNo: data.vatNo ?? null,
  country: data.country ? mapCountryDTOtoCountry(data.country) : null,
});

export class OrganizationService {
  createOrganization(organizationData: Partial<Organization>) {
    return directusClient.createOrganization(organizationData);
  }

  async updateOrganization(
    organizationId: string,
    organizationData: Partial<Organization>,
  ) {
    return directusClient.updateOrganization(organizationId, organizationData);
  }

  async updateOrganizationInWizard(
    organizationId: string,
    organizationData: Partial<Organization>,
  ): Promise<NewOrganizationDto> {
    const data = await directusClient.updateOrganization(
      organizationId,
      organizationData,
    );
    return DTOtoWizard(data);
  }

  async getOrganizationById(organizationId: string): Promise<OrganizationDto> {
    return directusClient.getOrganizationById(organizationId);
  }

  async getAllOrganizations(): Promise<NewOrganizationDto[]> {
    const data = await directusClient.getAllOrganisations();
    return data.map(DTOtoWizard);
  }

  acceptInvite(organization: string, token: string) {
    return directusClient.acceptOrganizationInvite(organization, token);
  }
}

const organizationService = new OrganizationService();
export default organizationService;

export const deleteOrganization = async (organizationId: string) => {
  return directusClient.deleteOrganization(organizationId);
};

export async function getOrganizationCount(): Promise<number> {
  // TODO: Use our own endpoint!
  const { data } = await getApiClientByBodyType('json').get<{
    data: { count: number }[];
  }>('items/organization?aggregate[count]=*');

  const entry = data[0];
  if (!entry) {
    throw new Error('Unexpected response format');
  }
  return entry.count;
}
